import type { SvgIconComponent } from '@mui/icons-material';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

import type { ProductId } from './types';

export const PRODUCT_ICONS: Record<ProductId, SvgIconComponent> = {
  membership_monthly: CalendarMonthIcon,
  membership_annual: WorkspacePremiumIcon,
  org_program: AllInclusiveIcon,
};

export function getProductIcon(productId: ProductId): SvgIconComponent {
  return PRODUCT_ICONS[productId];
}
